import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  /**
   * Get item by key
   */
  public getItem(key: string) {
    let keyEncoded = null;
    let valueDecoded = null;
    let valueEncoded = null;

    keyEncoded = btoa(key);
    valueEncoded = localStorage.getItem(keyEncoded);

    if (valueEncoded !== null) {
      valueDecoded = atob(valueEncoded);
    }

    return JSON.parse(valueDecoded);
  }

  /**
   * Set item by key and value
   */
  public setItem(key: string, value: any) {
    return new Promise((resolve, reject) => {
      let keyEncoded = null;
      let valueEncoded = null;

      keyEncoded = btoa(key);
      valueEncoded = btoa(JSON.stringify(value));

      localStorage.setItem(keyEncoded, valueEncoded);
      if (this.getItem(key)) {
        resolve(true);
      } else {
        reject(false);
      }
    });
  }

  /**
   *
   * Delete item by key
   */
  removeItem(key: string) {
    try {
      const keyEncoded = btoa(key);
      localStorage.removeItem(keyEncoded);
    } catch (error) {
      // Error
      localStorage.removeItem(key);
    }
  }
}
